import { useState } from 'react'
import { subDays } from 'date-fns'
import type { DateRange } from './reportHooks'

export function useReportDateRange(initialDays = 30) {
  return useState<DateRange>(() => ({
    from: subDays(new Date(), initialDays - 1),
    to: new Date(),
  }))
}
